// extracted by mini-css-extract-plugin
export default {"introSection":"IPhonePage_introSection__9S+z2"};